import { render, staticRenderFns } from "./CardProduct.vue?vue&type=template&id=16b32bdb&scoped=true"
import script from "./CardProduct.vue?vue&type=script&lang=js"
export * from "./CardProduct.vue?vue&type=script&lang=js"
import style0 from "./CardProduct.vue?vue&type=style&index=0&id=16b32bdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b32bdb",
  null
  
)

export default component.exports